var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00383 17H12.7031C14.6401 17 15.4459 14.5218 13.8794 13.3825L13.0304 12.7651C12.3467 12.2678 11.5231 12 10.6777 12H5.0292C4.18383 12 3.3602 12.2678 2.67651 12.7651L1.82749 13.3825C0.261003 14.5218 1.06687 17 3.00383 17Z",
    fill: "#FAE6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8535 5C11.8535 7.20914 10.0627 9 7.85352 9C5.64438 9 3.85352 7.20914 3.85352 5C3.85352 2.79086 5.64438 1 7.85352 1C10.0627 1 11.8535 2.79086 11.8535 5Z",
    fill: "#FAE6E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88083 12.7C4.2151 12.7 3.56649 12.9109 3.02809 13.3025L2.17907 13.92C1.27834 14.575 1.74171 16 2.85546 16H12.5547C13.6685 16 14.1319 14.575 13.2311 13.92L12.3821 13.3025C11.8437 12.9109 11.1951 12.7 10.5294 12.7H4.88083ZM2.0282 11.9276C2.85716 11.3247 3.85582 11 4.88083 11H10.5294C11.5544 11 12.553 11.3247 13.382 11.9276L12.882 12.6151L13.382 11.9276L14.231 12.5451C16.4633 14.1686 15.3149 17.7 12.5547 17.7H2.85546C0.095294 17.7 -1.05307 14.1686 1.17918 12.5451L2.0282 11.9276Z",
    fill: "#A51713"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70498 1.7C5.96528 1.7 4.55498 3.1103 4.55498 4.85C4.55498 6.5897 5.96528 8 7.70498 8C9.44468 8 10.855 6.5897 10.855 4.85C10.855 3.1103 9.44468 1.7 7.70498 1.7ZM2.85498 4.85C2.85498 2.17142 5.0264 0 7.70498 0C10.3836 0 12.555 2.17142 12.555 4.85C12.555 7.52858 10.3836 9.7 7.70498 9.7C5.0264 9.7 2.85498 7.52858 2.85498 4.85Z",
    fill: "#A51713"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.89818a179a280b9d8a268681c329a0a0.svg";
export { ForwardRef as ReactComponent };